import { Button, Dialog, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../components/DialogTitleWithCloseButton";
import AttachmentInput from "../../components/AttachmentInput";
import { errorToast, successToast } from "../../toast";
import swal from "sweetalert";
import { showLoading, hideLoading } from "../../loading";
import { PAYMENT_TYPE } from "../../../../shared/constants";
import EditableTextbox from "../../components/EditableTextbox";
import SearchItem from "../../components/SearchItem";
import request from "../../request";


export default class RecordPayment extends Component {

   state = {
      type: '',
      attachment: null,
      amount: '',
      paid_at: '',
   }


   submit = async () => {

      // validate form
      const txtType = document.getElementById('txt-type');
      const txtAmount = document.getElementById('txt-amount');
      const txtPaidAt = document.getElementById('txt-paid-at');

      const { type, attachment, amount, paid_at } = this.state;

      if (this.props.amountField && !amount) {
         errorToast("Please enter amount");
         return txtAmount.focus();
      }

      if (!type) {
         errorToast("Please select payment type");
         return txtType.focus();
      }

      if (!attachment) {
         errorToast("Please select proof of payment");
         return;
      }

      if (this.props.paidAtField && !paid_at) {
         errorToast("Please provide the time of payment");
         return txtPaidAt.focus();
      }

      if (this.props.bankAccountField && !this.state.bank_account) {
         errorToast("Please select a bank account");
         return;
      }

      // submit
      try {

         showLoading();

         const data = {
            type,
            attachments: [ attachment ],
         };

         if (this.props.amountField)
            data.amount = parseFloat(amount) || 0;

         if (this.props.paidAtField)
            data.paid_at = paid_at;

         if (this.props.bankAccountField)
            data.bank_account = this.state.bank_account.id;

         const res = await this.props.submit(data);

         successToast("Success");
         this.props.onClose(res);

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }
   }

   componentDidMount() {
      if (this.props.amount)
         this.setState({ amount: this.props.amount });
   }

   render() {

      // TODO: add field for payment_ref
      // TODO: feature to allow multiple attachments
      
      return <Dialog open fullWidth maxWidth="xs">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            {this.props.title || "Record Payment"}
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="flex flex-col gap-6 p-4">
               {
                  this.props.amountField && <>
                     {
                        this.props.amount ? <EditableTextbox
                           id="txt-amount"
                           label="Amount"
                           value={this.state.amount}
                           onChange={amount => this.setState({ amount })}
                           defaultValue={this.props.amount}
                           size="small"
                           type="number"
                        /> : <TextField
                           id="txt-amount"
                           label="Amount"
                           type="number"
                           size="small"
                           variant="outlined"
                           fullWidth
                           value={this.state.amount}
                           onChange={e => this.setState({ amount: e.target.value })}
                        />
                     }
                  </>
               }
               <TextField
                  id="txt-type"
                  label="Payment Type"
                  select
                  value={this.state.type}
                  onChange={e => this.setState({ type: e.target.value })}
                  fullWidth
                  size="small"
               >
                  {
                     Object.values(PAYMENT_TYPE).map(type =>
                        <MenuItem key={type} value={type}>{type.toUpperCase()}</MenuItem>
                     )
                  }
               </TextField>
               <AttachmentInput
                  label="Proof of Payment"
                  name={this.state.attachment?.name}
                  onChange={attachment => this.setState({ attachment })}
               />
               {
                  this.props.paidAtField && <TextField
                     id="txt-paid-at"
                     label="Paid At"
                     type="datetime-local"
                     size="small"
                     variant="outlined"
                     fullWidth
                     slotProps={{
                        inputLabel: {
                           shrink: true
                        }
                     }}
                     onChange={e => this.setState({ paid_at: e.target.value })}
                  />
               }
               {
                  this.props.bankAccountField && <SearchItem
                     label="Bank Account"
                     size="small"
                     value={this.state.bank_account}
                     fetchData={
                        async () => {
                           const res = await request.get('/api/general/quickbooks/bank-accounts');
                           return res.data.accounts;
                        }
                     }
                     transformOption={item => ({ ...item, label: item.name })}
                     onChange={bank_account => this.setState({ bank_account })}
                  />
               }
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant="contained" onClick={this.submit}>
               SUBMIT
            </Button>
         </DialogActions>
      </Dialog>
   }
}